<template lang="pug">
	.campaign-keywords(v-if="info")
		DxTagBox(
			:accept-custom-value="true",
			:search-enabled="true",
			:value="keywords",
			:show-selection-controls="true",
			:openOnFieldClick="false",
			@value-changed="onValueChanged")
			DxTagBoxButton(v-if="!keywords.length", name="help", :options="{text: $tCaption('I need help'), icon: 'help', stylingMode: 'text', onClick: () => showSuggester() }")
			DxTagBoxButton(v-if="keywords.length", name="clearAll", :options="{text: '', icon: 'clear', type: 'default', onClick: () => keywords = []}")
		Popup(v-if="suggesterPopupVisible", :popupVisible="suggesterPopupVisible", :width="960", :height="420")
			KeywordsSuggester(:data="{ advertiserIndustry: campaignIndustryName, advertiserName: campaignAdvertiserName }", @get-keywords="setSuggesterKeywords", @cancel="suggesterPopupVisible = false"
				@industry-selected="onIndustrySelected")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import { DxTagBox, DxButton as DxTagBoxButton  } from 'devextreme-vue/tag-box';
	import Loader from 'app-core/Loader.vue';
	import Popup from 'app-core/Popup.vue';
	import KeywordsSuggester from './KeywordsSuggester';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-keywords',
		components: {
			DxButton, DxTagBox, Loader, DxTagBoxButton, Popup, KeywordsSuggester
		},
		props: ['info'],
		data() {
			return {
				suggesterPopupVisible: false
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			},
			campaignProducts() {
				return this.info?.campaignProducts;
			},
			keywords: {
				get: function() { 
					return (this.campaign.TargetKeywords || '').split(',').map(f => `${f}`.trim()).filter(f => f);
				},
				set: function(v) {
					this.campaign.TargetKeywords = v?.length && v.join(',') || '';
				}
			},
			campaignAdvertiserName() {
				return this.info?.campaign?.Advertiser?.Name;
			},
			campaignIndustryName() {
				return this.info?.campaign?.IabCategories?.slice(0, 1)[0]?.Name;
			}
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.campaignKeywords = this;
		},
		methods: {
			onValueChanged(e) {
				if (__DEBUG__)
					console.debug('OnValueChanged', { e });
				this.keywords = e.value;
			},
			setSuggesterKeywords(v) {
				this.keywords = v;
				this.suggesterPopupVisible = false;
			},
			showSuggester() {
				this.suggesterPopupVisible = false;
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.suggesterPopupVisible = true;
				});
			},
			onIndustrySelected(v) {
				this.$emit('industry-selected', v);
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.campaign-keywords {

	}
</style>
 